import React from 'react';
import cx from 'classnames';
import {LayoutContext} from '../ProductPageApp/ProductPageApp';
import s from './ProductName.scss';
import {ProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';

export interface ProductNameProps extends ProvidedGlobalProps {
  name: string;
}

export const ProductNameDataHook = 'product-title';

class ProductNameComp extends React.Component<ProductNameProps> {
  public render(): JSX.Element {
    return (
      <LayoutContext.Consumer>
        {(layoutName) => (
          <h1 data-hook={ProductNameDataHook} className={cx(s.productName, s[`productName__${layoutName}`])}>
            {this.props.name}
          </h1>
        )}
      </LayoutContext.Consumer>
    );
  }
}

export const ProductName = withGlobalProps(ProductNameComp);
